module.exports = __webpack_public_path__ + "static/media/Smart-Axiata.71885fee.png";